import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入组件


import index from '../views/index.vue'
/* 配置路由 */
const routes =[
	{
		path:'/:name*',name:'index',component:index,
		// children: [
		// 	{ path: '', component: index }
		// ]
	}
]
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter)



var router =  new VueRouter({
	/* linkActiveClass: 'on', */
	 /* linkExactActiveClass: 'on', */

    mode: 'history',
    routes
})
export default router